module.exports = __webpack_public_path__ + "assets/img/top-bg-79b44075.png";